import axios from "axios";
import backendUrl from "./constant/backendUrl";


export async function insertAgent(formData){
    let url = `${backendUrl}/Agent/Create`;
    var jsonData = JSON.stringify(formData);
    console.log("url is " + url);
    console.log(jsonData);
   return  axios.post(url, formData)
}
